/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { AddressComponentMapper } from '../address-component-mapper.interface';
import { AddressDTO } from "@well/address-management-domain-model";

export abstract class BaseAddressComponentMapper implements AddressComponentMapper {

  protected addressComponent: google.maps.GeocoderAddressComponent | undefined = undefined;

  public constructor(addressComponent: google.maps.GeocoderAddressComponent) {
    this.addressComponent = addressComponent;
  }

  abstract mapAddress(address: AddressDTO);
}

